import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
import { SelectOrder } from "./SelectOrder";
import { SelectOrderItems } from "./SelectOrderItems";
import { DeliveryDisplay } from "./DeliveryDisplay";
import { OrderDisplay } from "../../Orders/UI/OrderDisplay";
export class DeliveryCard extends React.Component {
  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Delivery"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-1"></div>
                <div className="ui-g-10">
                  <pr.TabView onTabChange={e => {}}>
                    <pr.TabPanel header="Order Details">
                      {!format.isNotNull(this.props.selectedOrder) && (
                        <SelectOrder
                          editedObject={this.props.editedObject}
                          orderList={this.props.orderList}
                          orderExpandedRows={this.props.orderExpandedRows}
                          updateState={this.props.updateState}
                          orderTableColumns={this.props.orderTableColumns}
                          selectOrder={this.props.selectOrder}
                        />
                      )}
                      {format.isNotNull(this.props.selectedOrder) && (
                        <React.Fragment>
                          <DeliveryDisplay data={this.props.editedObject} />
                          {this.props.crudlState === CrudlStatus.CREATE && (
                            <pr.Button
                              type="button"
                              label={"Change Order"}
                              className="p-button-success"
                              onClick={() => {
                                this.props.selectOrder(null);
                              }}
                              style={{ marginRight: ".5em", float: "right" }}
                            ></pr.Button>
                          )}
                        </React.Fragment>
                      )}
                    </pr.TabPanel>

                    <pr.TabPanel header="Items">
                      {format.isNotNull(this.props.editedObject) && (
                        <React.Fragment>
                          {this.getOrderItemsDisplayTable(
                            this.props.editedObject.shipTogether,
                            this.props.selectedOrderItems
                          )}
                        </React.Fragment>
                      )}

                      {format.isNotNull(this.props.editedObject) && (
                        <div className="ui-g-12 card-round">
                          <div>
                            {this.getDeliveryItemsDisplayTable(
                              this.props.editedObject.shipTogether,
                              this.props.editedObject.deliveryItemRequestList
                            )}
                          </div>
                        </div>
                      )}
                    </pr.TabPanel>
                  </pr.TabView>
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
  getDeliveryItemsDisplayTable = (shipTogether, deliveryItemRequestList) => {
    let flaggedColumns = [];
    if (shipTogether !== true) {
      flaggedColumns.push(
        <pr.Column
          key="add"
          field="shipTogether"
          header="Ship Together?"
          body={this.getDeliveryItemShipTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="quantity"
          header="Order Item Total Quantity"
          field="quantity"
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="quantityAdded"
          header="Quantity Assigned"
          field="quantityAdded"
          editor={this.deliveryItemQuantityEditor}
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="remove"
          body={this.getDeliveryItemRemoveTemplate}
          style={{ textAlign: "center", width: "8em" }}
        />
      );
    } else {
      flaggedColumns.push(
        <pr.Column
          key="quantity"
          header="Order Item Total Quantity"
          field="quantity"
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
      flaggedColumns.push(
        <pr.Column
          key="quantityAdded"
          field="quantityAdded"
          header="Quantity"
          editor={this.deliveryItemQuantityEditor}
          style={{ overflow: "auto", backgroundColor: "white" }}
        />
      );
    }
    return (
      <div>
        <pr.DataTable
          ref={el => {
            this.dt = el;
          }}
          reorderableColumns={false}
          selectionMode="single"
          onSelectionChange={e => {}}
          value={deliveryItemRequestList}
          dataKey="id"
          emptyMessage="This Delivery contains no items"
          rows={100}
          autoLayout={true}
          header={
            <div className="ui-g">
              <div className="ui-g-12">
                {this.props.editedObject.shipTogether !== true && (
                  <pr.Button
                    type="button"
                    icon="pi pi-plus"
                    label={"Add Delivery Item"}
                    className="p-button-success"
                    onClick={() => {
                      this.props.updateState("selectedOrderItemsDialog", true);
                    }}
                    style={{ marginRight: ".5em", float: "right" }}
                  ></pr.Button>
                )}
              </div>
            </div>
          }
        >
          <pr.Column
            field="productName"
            header="Name"
            style={{ overflow: "auto", backgroundColor: "white" }}
          />
          <pr.Column
            field="productDescription"
            header="Description"
            style={{ overflow: "auto", backgroundColor: "white" }}
          />

          {flaggedColumns}
        </pr.DataTable>
      </div>
    );
  };

  getDeliveryItemShipTemplate = rowData => {
    return (
      <div>
        <pr.TriStateCheckbox
          disabled={true}
          onLabel="Yes"
          offLabel="No"
          value={rowData.shipTogether}
        />
      </div>
    );
  };
  getDeliveryItemRemoveTemplate = (rowData, column) => {
    return (
      <div>
        <pr.Button
          type="button"
          icon="pi pi-trash"
          className="p-button-success"
          onClick={e => {
            this.onDeliveryItemRemove(rowData);
          }}
          style={{ marginRight: ".5em" }}
        ></pr.Button>
      </div>
    );
  };
  deliveryItemQuantityEditor = props => {
    console.log(props);
    return this.deliveryItemInputTextEditor(props, "quantityAdded");
  };

  deliveryItemInputTextEditor = (props, field) => {
    if (props.rowData.shipTogether) {
      return (
        <div className="ui-g-12">
          <label>{props.rowData[field] || ""}</label>
        </div>
      );
    } else {
      return (
        <pr.InputText
          type="text"
          keyfilter="int"
          value={props.rowData[field] || ""}
          onChange={e =>
            this.onDeliveryItemEditorValueChange(
              props.rowIndex,
              props.field,
              e.target.value
            )
          }
        />
      );
    }
  };

  onDeliveryItemEditorValueChange = (row, field, value) => {
    let updatedList = this.props.editedObject.deliveryItemRequestList;
    updatedList[row][field] = value;

    var deliveryItemRequestList = updatedList;
    var editedObject = this.props.editedObject;
    editedObject.deliveryItemRequestList = deliveryItemRequestList;

    this.props.updateState("editedObject", editedObject);
  };

  onDeliveryItemRemove = rowData => {
    var newList = [];
    var deleteList = [];
    let updatedList = this.props.editedObject.deliveryItemRequestList;
    updatedList.forEach(element => {
      if (element.id === rowData.id) {
        if (format.isNotNull(element.crudlStatus)) {
          deleteList.push(rowData);
        }
      } else {
        newList.push(element);
      }
    });

    var deliveryItemRequestList = newList;
    var editedObject = this.props.editedObject;
    editedObject.deliveryItemRequestList = deliveryItemRequestList;

    this.props.updateState("editedObject", editedObject);

    var currentDeletedOrderItems = this.props.deletedDeliveryItemList;
    if (format.isNotNull(currentDeletedOrderItems)) {
      this.props.updateState("deletedDeliveryItemList", deleteList);
    } else {
      if (format.isNotNull(deleteList)) {
        deleteList.forEach(element => {
          if (!format.isNotNull(currentDeletedOrderItems)) {
            currentDeletedOrderItems = [];
          }
          currentDeletedOrderItems.push(element);
        });
      }
      this.props.updateState(
        "deletedDeliveryItemList",
        currentDeletedOrderItems
      );
    }
  };

  getOrderItemsDisplayTable = (shipTogether, orderItemResponseList) => {
    return (
      <pr.Dialog
        visible={this.props.selectedOrderItemsDialog}
        //style={{ backgroundColor: "#043066", color: "white" }}
        modal={false}
        onHide={e => {
          this.props.updateState("selectedOrderItemsDialog", false);
          this.props.resetOrderItems();
        }}
      >
        <SelectOrderItems
          selectedOrderItems={orderItemResponseList}
          updateState={this.props.updateState}
          shipTogether={shipTogether}
          editedObject={this.props.editedObject}
        />
      </pr.Dialog>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Deliverys/UI/DeliveryCard.js